import { render, staticRenderFns } from "./customModel.vue?vue&type=template&id=37d54715&scoped=true"
import script from "./customModel.vue?vue&type=script&lang=js"
export * from "./customModel.vue?vue&type=script&lang=js"
import style0 from "./customModel.vue?vue&type=style&index=0&id=37d54715&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d54715",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d54715')) {
      api.createRecord('37d54715', component.options)
    } else {
      api.reload('37d54715', component.options)
    }
    module.hot.accept("./customModel.vue?vue&type=template&id=37d54715&scoped=true", function () {
      api.rerender('37d54715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customManage/customModel.vue"
export default component.exports